import { CreditCard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/lib/router-compat";

export const SaintCost = () => (
  <section className="py-16 sm:py-20 bg-muted/30">
    <div className="container-px mx-auto max-w-4xl px-4">
      <div className="text-center mb-10">
        <span className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-accent">
          <CreditCard className="h-4 w-4" />
          Cost, insurance &amp; financing
        </span>
        <h2 className="mt-3 font-headings text-2xl font-bold text-primary sm:text-3xl lg:text-4xl">
          Straight answers on cost
        </h2>
      </div>

      <div className="space-y-4">
        <div className="rounded-2xl border-2 border-accent/30 bg-accent/[0.04] p-6 shadow-premium">
          <div className="flex items-center gap-2 mb-2">
            <span className="rounded-full bg-gradient-accent px-2.5 py-0.5 text-xs font-bold text-accent-foreground">
              Most Common
            </span>
            <h3 className="font-headings text-base font-bold text-primary">
              Self-Pay — fastest path to treatment
            </h3>
          </div>
          <p className="text-sm text-foreground/80 leading-relaxed">
            Our most common option offers the greatest speed and flexibility.
            Most patients move from consultation to treatment within a few days.
            With our recently expanded facilities, we offer private treatment
            suites, extended care team hours, and appointments seven days a
            week. Self-pay typically ranges from $25,000 to $28,000, and pricing
            is reviewed with you individually during your consultation so you
            know your cost before committing.
          </p>
        </div>

        <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
          <h3 className="font-headings text-base font-bold text-primary mb-2">
            Select Insurance Plans — BCBS in select states
          </h3>
          <p className="text-sm text-foreground/80 leading-relaxed">
            We accept Blue Cross Blue Shield in select states and the Blue Cross
            Blue Shield Federal Employee Program in select states. Because
            insurance requires a review and approval process, this pathway
            generally takes longer from consultation to treatment. Our team
            handles benefits verification, prior authorization, and all required
            documentation — guiding you through every step.
          </p>
        </div>

        <div className="rounded-2xl border border-border bg-card p-6 shadow-soft">
          <h3 className="font-headings text-base font-bold text-primary mb-2">
            Billing codes for your insurer
          </h3>
          <p className="text-sm text-foreground/85 leading-relaxed">
            SAINT uses Category III CPT codes:{" "}
            <strong>0889T, 0890T, 0891T, 0892T</strong>. Your insurer may use
            these codes to process your claim.
          </p>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Button
          asChild
          size="lg"
          className="bg-gradient-accent text-accent-foreground shadow-glow hover:opacity-90"
        >
          <Link to="/check-my-insurance-options">Verify my insurance</Link>
        </Button>
      </div>
    </div>
  </section>
);
